import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        app: {
            application_id: 0,
            name: "Default",
            description: "Application de test",
            icon: "/static/images/icons/default.png",
            url: "https://account.vlq16.iliad.fr/",
            application_visibility_id: "1",
        },
    },
    actions: {
        getApp: ({ commit }, appId) => {
            return Vue.http.get('app/' + appId)
                .then(r => {
                    commit("SET_APPLICATION", r.body)
                    return r
                })
        },
        updateApplication: ({ state }) => {
            return Vue.http.put('app/' + state.app.application_id, {
                name : state.app.name,
                description: state.app.description,
                url: state.app.url,
                application_visibility_id: state.app.application_visibility_id
            }, { emulateJSON: true })
        },
        updateName: ({ commit }, value) => {
            commit("UPDATE_APPLICATION_NAME", value)
        },
        updateDesc: ({ commit }, value) => {
            commit("UPDATE_APPLICATION_DESC", value)
        },
        updateUrl: ({ commit }, value) => {
            commit("UPDATE_APPLICATION_URL", value)
        },
        updateVisibility: ({ commit, dispatch }, value) => {
            commit("UPDATE_APPLICATION_VISIBILITY", value)
            dispatch('updateApplication')
        },
    },
    mutations:{
        SET_APPLICATION: (state, data) => {
            return state.app = data
        },
        UPDATE_APPLICATION_NAME: (state, value) => {
            return state.app.name = value
        },
        UPDATE_APPLICATION_DESC: (state, value) => {
            return state.app.description = value
        },
        UPDATE_APPLICATION_URL: (state, value) => {
            return state.app.url = value
        },
        UPDATE_APPLICATION_VISIBILITY: (state, value) => {
            return state.app.application_visibility_id = value
        },
    },
    getters: {
        app: (state) => state.app
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/adminApp.js